import { Box, TableContainer } from '@mui/material';
import { Table, TableBody, TableHead } from '@mui/material/';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';

import { useT } from 'UI/lib';

const BasicInfoTable = ({
  columns,
  data,
  tableProps,
  tableHeaderRowProps,
  tableDataRowProps,
  tableContainerProps,
}) => {
  const t = useT();
  return (
    <TableContainer component={Box} {...tableContainerProps}>
      <Table aria-label="basic info table" {...tableProps}>
        <TableHead>
          <TableRow {...tableHeaderRowProps}>
            {Object.entries(columns).map(([key, value], index) => (
              <TableCell key={`${key}-${index}`}>
                <Typography sx={theme => ({ color: theme.palette.custom.primary })}>
                  {t(value)}
                </Typography>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map(item => (
            <TableRow key={item.name} {...tableDataRowProps}>
              {Object.keys(columns).map((key, index) => (
                <TableCell key={`${key}-${index}-cell}`}>{item[key]}</TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default BasicInfoTable;
